import React from 'react'
import {
  Responsive,
  Segment
} from 'semantic-ui-react'
// Local
import {
  shouldRenderReskin2025,
  TABLET_WIDTH
} from '../../../constant'
import PatientProfile from './patientProfile'
import { Encounter } from '../../authenticated/types'
import If from '../../common/if'

type Props = {
  encounter: Encounter | undefined
  mode: string
}

function EncounterProfile(
  props: Props
): JSX.Element | null {
  const {
    encounter,
    mode
  } = props
  const patientID = (
    encounter &&
    encounter.patient &&
    encounter.patient.id
  )
  const imageClassName = shouldRenderReskin2025
    ? 'left-segment-image reskin'
    : 'left-segment-image'
  if (mode === 'left') {
    return (
      (
        <Responsive
          as={ Segment }
          attached
          className={ imageClassName }
          minWidth={ TABLET_WIDTH.minWidth }
        >
          <If isTrue={ !!patientID }>
            <PatientProfile
              key={ `patient-profile-${patientID}` }
              patientId={ patientID || '' }
              clazz="left-image"
            />
          </If>
        </Responsive>
      )
    )
  }
  return null
}

export default EncounterProfile
